import React, { useContext, useState } from "react";
import { css } from "emotion";
import { BuildContext } from "../../context/BuildSpotlightState";
import GenericTextInput from "../GenericTextInput";
import Section from "../createNew/Section";
import { boxStyles, colors, textSizes } from "../../styles/theme";
import NextButton from "./NextButton";
import TitleBlock from "./TitleBlock";

const CtaBuilder = () => {
  const {
    ctaText,
    setCtaText,
    ctaUrl,
    setCtaUrl,
    setStage,
    setLastCompleted,
  } = useContext(BuildContext);
  const [error, setError] = useState("");
  const handleSubmit = (e) => {
    e.preventDefault();
    // do some validation here and show errors
    if (!ctaText || !ctaUrl) {
      setError(
        "Make sure you fill out all the fields, or skip if you do not want a CTA button."
      );
      return;
    }
    setError("");
    setStage(4);
    setLastCompleted(4);
  };

  const handleSkip = () => {
    setCtaText("");
    setCtaUrl("");
    setStage(4);
    setLastCompleted(4);
  };

  return (
    <form className={container} onSubmit={handleSubmit}>
      <TitleBlock/>
      <Section heading="Button Text">
        <GenericTextInput
          placeholder="Input text here..."
          value={ctaText}
          onValueChange={setCtaText}
          maxLength={12}
        />
      </Section>
      <Section heading="Button URL">
        <GenericTextInput
          placeholder="https://"
          needsCounter={false}
          value={ctaUrl}
          onValueChange={setCtaUrl}
        />
      </Section>
      <NextButton />
      <p className="skip-btn" onClick={handleSkip}>
        skip
      </p>

      {error && (
        <div className="errorBox">
          <p>{error}</p>
        </div>
      )}
    </form>
  );
};

export default CtaBuilder;

const container = css`
  padding: ${boxStyles.standardPadding};
  display: flex;
  flex-direction: column;
  align-items: center;

  .skip-btn {
    color: ${colors.brandColor};
    font-size: ${textSizes.intermediate};
    cursor: pointer;
  }

  .errorBox {
    padding: ${boxStyles.standardPadding} 0;
    p {
      font-size: ${textSizes.normal};
      color: ${colors.cancel};
      text-align: center;
    }
  }
`;
